export const ENTITY_CONFIG = {
  properties: {
    label: "Properties",
    apiPath: "properties",
    responseKey: "properties",
    nameField: "name",
    fields: [
      { key: "name", label: "Property Name", type: "text", required: true },
      { key: "city", label: "City", type: "text", required: true },
      { key: "state", label: "State", type: "text", required: true },
      { key: "state_code", label: "State Code", type: "text", required: true, placeholder: "TX" },
      { key: "sector", label: "Sector", type: "select", required: true, options: ["Industrial", "Multifamily", "Office", "Retail", "Hospitality", "Data Centers", "Healthcare", "Student Housing"] },
      { key: "value", label: "Value ($)", type: "number", required: true },
      { key: "noi", label: "NOI ($)", type: "number", required: true },
      { key: "occupancy_rate", label: "Occupancy Rate (%)", type: "number", required: true },
      { key: "cap_rate", label: "Cap Rate (%)", type: "number", required: true },
      { key: "rental_growth", label: "Rental Growth (%)", type: "number" },
      { key: "ltv", label: "LTV (%)", type: "number" },
      { key: "dscr", label: "DSCR", type: "number" },
      { key: "year_acquired", label: "Year Acquired", type: "number" },
      { key: "sq_ft", label: "Square Feet", type: "number" },
    ],
  },
  funds: {
    label: "Funds",
    apiPath: "funds",
    responseKey: "funds",
    nameField: "name",
    fields: [
      { key: "name", label: "Fund Name", type: "text", required: true },
      { key: "manager", label: "Manager", type: "text", required: true },
      { key: "strategy", label: "Strategy", type: "select", required: true, options: ["Opportunistic", "Value-Add", "Core", "Core-Plus", "Debt"] },
      { key: "vintage_year", label: "Vintage Year", type: "number", required: true },
      { key: "committed_capital", label: "Committed Capital ($)", type: "number", required: true },
      { key: "invested_capital", label: "Invested Capital ($)", type: "number", required: true },
      { key: "nav", label: "NAV ($)", type: "number", required: true },
      { key: "distributions", label: "Distributions ($)", type: "number" },
      { key: "irr", label: "IRR (%)", type: "number", required: true },
      { key: "moic", label: "MOIC (x)", type: "number" },
      { key: "dpi", label: "DPI (x)", type: "number" },
      { key: "tvpi", label: "TVPI (x)", type: "number" },
      { key: "rvpi", label: "RVPI (x)", type: "number" },
      { key: "status", label: "Status", type: "select", options: ["Active", "Harvesting", "Closed"] },
    ],
  },
  managers: {
    label: "Managers",
    apiPath: "managers",
    responseKey: "managers",
    nameField: "name",
    fields: [
      { key: "name", label: "Manager Name", type: "text", required: true },
      { key: "headquarters", label: "Headquarters", type: "text", required: true },
      { key: "aum", label: "AUM ($)", type: "number", required: true },
      { key: "num_funds", label: "Number of Funds", type: "number" },
      { key: "avg_irr", label: "Avg IRR (%)", type: "number" },
      { key: "total_properties", label: "Total Properties", type: "number" },
      { key: "founded", label: "Year Founded", type: "number" },
      { key: "strategy_focus", label: "Strategy Focus", type: "text" },
    ],
  },
  sectors: {
    label: "Sectors",
    apiPath: "sectors",
    responseKey: "sectors",
    nameField: "name",
    fields: [
      { key: "name", label: "Sector Name", type: "select", required: true, options: ["Industrial", "Multifamily", "Office", "Retail", "Hospitality", "Data Centers", "Healthcare", "Student Housing"] },
      { key: "total_value", label: "Total Value ($)", type: "number", required: true },
      { key: "allocation_pct", label: "Allocation (%)", type: "number", required: true },
      { key: "irr", label: "IRR (%)", type: "number" },
      { key: "benchmark_irr", label: "Benchmark IRR (%)", type: "number" },
      { key: "occupancy", label: "Occupancy (%)", type: "number" },
      { key: "cap_rate", label: "Cap Rate (%)", type: "number" },
      { key: "rental_growth", label: "Rental Growth (%)", type: "number" },
      { key: "num_properties", label: "Properties", type: "number" },
      { key: "noi", label: "NOI ($)", type: "number" },
    ],
  },
  geography: {
    label: "Geography",
    apiPath: "geography",
    responseKey: "geography",
    nameField: "state",
    fields: [
      { key: "state", label: "State Name", type: "text", required: true },
      { key: "state_code", label: "State Code", type: "text", required: true, placeholder: "TX" },
      { key: "value", label: "Value ($)", type: "number", required: true },
      { key: "irr", label: "IRR (%)", type: "number" },
      { key: "num_properties", label: "Properties", type: "number" },
      { key: "occupancy", label: "Occupancy (%)", type: "number" },
      { key: "cap_rate", label: "Cap Rate (%)", type: "number" },
      { key: "noi", label: "NOI ($)", type: "number" },
    ],
  },
  benchmarks: {
    label: "Benchmarks",
    apiPath: "benchmarks",
    responseKey: "benchmarks",
    nameField: "metric",
    fields: [
      { key: "source", label: "Source", type: "select", required: true, options: ["NCREIF", "MSCI", "Green Street"] },
      { key: "metric", label: "Metric", type: "text", required: true },
      { key: "portfolio_value", label: "Portfolio Value", type: "number", required: true },
      { key: "benchmark_value", label: "Benchmark Value", type: "number", required: true },
      { key: "spread", label: "Spread", type: "number" },
      { key: "period", label: "Period", type: "text" },
    ],
  },
  risk_scenarios: {
    label: "Risk Scenarios",
    apiPath: "risk/scenarios",
    responseKey: "scenarios",
    nameField: "name",
    fields: [
      { key: "name", label: "Scenario Name", type: "text", required: true },
      { key: "description", label: "Description", type: "text", required: true },
      { key: "parameter", label: "Parameter", type: "text", required: true },
      { key: "change", label: "Change", type: "text", required: true },
      { key: "portfolio_value_impact", label: "Portfolio Impact (%)", type: "number", required: true },
      { key: "noi_impact", label: "NOI Impact (%)", type: "number" },
      { key: "nav_impact", label: "NAV Impact ($)", type: "number" },
      { key: "severity", label: "Severity", type: "select", options: ["Critical", "High", "Medium", "Low"] },
      { key: "probability", label: "Probability", type: "select", options: ["High", "Medium", "Low"] },
    ],
  },
  cashflows: {
    label: "Cashflows",
    apiPath: "cashflows",
    responseKey: "cashflows",
    nameField: "year",
    fields: [
      { key: "year", label: "Year", type: "number", required: true },
      { key: "capital_calls", label: "Capital Calls ($)", type: "number", required: true },
      { key: "distributions", label: "Distributions ($)", type: "number", required: true },
      { key: "net_cashflow", label: "Net Cashflow ($)", type: "number" },
      { key: "cumulative_invested", label: "Cumulative Invested ($)", type: "number" },
      { key: "cumulative_distributed", label: "Cumulative Distributed ($)", type: "number" },
    ],
  },
};
